import * as React from 'react'
import {
  BUTTON_TYPE,
  Box,
  Button,
  COLOR,
  Column,
  DropdownLinks,
  FONT_SIZE,
  FONT_WEIGHT,
  Link,
  MenuProvider,
  NavMenu,
  Row,
  StylesProp,
  useMediaQuery,
  useTheme
} from '@ndlib/component-library'
import { getMenuItems } from '../../hooks/utils/getMenuItems'
import MaximumReadableWidth from '../MaximumReadableWidth'
import { useAuth } from '../../components/Providers/AuthProvider'
import { navigate } from 'gatsby'
import HoursIcon from '@mui/icons-material/AccessTime'
import DropDownIcon from '@mui/icons-material/ArrowDropDown'
import MenuIcon from '@mui/icons-material/Menu'
import { useLocation } from '@reach/router'

const NAV_BACKGROUND =  '#fff url(data:image/gif;base64,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)'

const MainNavigation = () => {
  const data = getMenuItems()
  const { authData, logIn, logOut } = useAuth()

  const rightMenuItemIds = ['search', 'login', 'hours', 'account']

  const expandedMenuItems = data.items
    .filter(item => !(
      rightMenuItemIds.includes(item.id) ||
      rightMenuItemIds.includes(`/${item.id}`)
    ))

  const expandedMenu = {
    ...data,
    items: expandedMenuItems
  }

  const accountMenuItems = [{
    value: 'items-requests',
    label: 'Items & Requests',
    onClick: () => {
      navigate('/account/items-requests')
    }
  }, {
    value: 'courses',
    label: 'Courses',
    onClick: () => {
      navigate('/account/courses')
    }
  }, {
    value: 'checkout-history',
    label: 'Checkout History',
    onClick: () => {
      navigate('/account/checkout-history')
    }
  }, {
    value: 'preferences',
    label: 'Preferences',
    onClick: () => {
      navigate('/account/preferences')
    }
  }, {
    value: 'reservations',
    label: 'Reservations',
    onClick: () => {
      navigate('/account/reservations')
    }
  }, {
    value: 'logout',
    label: 'Log Out',
    onClick: () => {
      logOut()
    }
  }]

  let mobileMenuItems = data.items
    .filter(item => !item.id.includes('home') && !item.id.includes('log'))
    .map(item => ({
      value: item.id,
      label: item.label,
      onClick: () => {
        let route = `${item.id}`
        if (route[0] !== '/') {
          route = `/${item.id}`
        }
        navigate(route)
      }
    }))

  if (authData) {
    mobileMenuItems = mobileMenuItems.concat([{
      value: 'account',
      label: 'My Account',
      onClick: () => {
        navigate('/account/preferences')
      }
    }, {
      value: 'items-requests',
      label: 'Items & Requests',
      onClick: () => {
        navigate('/account/items-requests')
      }
    }, {
      value: 'logout',
      label: 'Log Out',
      onClick: () => {
        logOut()
      }
    }]) 
  } else {
    mobileMenuItems = mobileMenuItems.concat([{
      value: 'login',
      label: 'Log In',
      onClick: () => {
        logIn()
      }
    }])
  }

  const location = useLocation();
  const theme = useTheme()
  const showSearch = location?.pathname !== '/'
  const showAccount = authData

  const menuButtonStyles: StylesProp = {
    mr: 6,
    py: 4,
    textDecoration: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontSize: FONT_SIZE.MS,
    fontWeight: FONT_WEIGHT.BOLD,
  }

  const menuButtonProps = {
    sx: menuButtonStyles,
    type: BUTTON_TYPE.TEXT,
    customColor: 'hsla(0, 0%, 100%, 0)',
  }

  const { breakpoint } = useMediaQuery()
  return (
    <Row
      sx={{
        background: NAV_BACKGROUND,
        borderBottom: '2px solid',
        borderColor: COLOR.ND_GOLD_LIGHT,
        maxWidth: '100%',
        position: 'relative',
        height: '52px',
        width: '100vw',
        zIndex: theme.zIndex.DIALOG,
      }}
    >
      <Box
        sx={{
          pl: 6,
          display: ['flex', 'flex', 'flex', 'none'],
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <DropdownLinks options={mobileMenuItems}>
          {({ anchorProps }) => (
            <Button primaryIcon={MenuIcon} {...anchorProps} type={BUTTON_TYPE.TEXT} />
          )}
        </DropdownLinks>
      </Box>
      <MaximumReadableWidth sx={{
        display: ['none', 'none', 'none', 'flex'],
      }}>
        <Row justify="space-between" sx={{width: '100%'}}>
          <MenuProvider menu={expandedMenu as any}>
            {({ menu, getMenuProps, getMenuItemProps, activePath, isOpen }) => (
              <Column>
                <Row
                  {...getMenuProps()}
                  sx={{ height: '100%' }}
                >
                  {menu.items.map((menuItem) => (
                    <Button
                      {...getMenuItemProps([menuItem.id])}
                      {...menuButtonProps}
                      style={{
                        outline: 'none',
                        textDecoration: (
                          activePath[0] === menuItem.id &&
                          activePath.length === 1 &&
                          isOpen
                        ) ? 'underline' : 'none',
                      }}
                      key={menuItem.id}
                      disableFocusStyles
                    >
                      {menuItem.label}
                    </Button>
                  ))}
                </Row>
                <NavMenu sx={{
                  bg: COLOR.WHITE,
                  width: '100vw',
                  position: 'absolute',
                  top: 'calc(100% + 2px)',
                  left: 0,
                  mx: 0,
                  borderRadius: 0
                }}/>
              </Column>
            )}
          </MenuProvider>
          <Row align="center">
            {showSearch && (
              <Button
                {...menuButtonProps}
                onClick={() => {
                  navigate('/search')
                }}
              >
                Search
              </Button>
            )}
            {showAccount && (
              <DropdownLinks options={accountMenuItems}>
                {({ anchorProps }) => (
                  <Button
                    {...menuButtonProps}
                    {...anchorProps}
                    rightIcon={DropDownIcon}
                  >
                    My Account
                  </Button>
                )}
              </DropdownLinks>
            )}
            {!showAccount && (
              <Button
                {...menuButtonProps}
                onClick={() => {
                  logIn()
                }}
              >
                Log In
              </Button>
            )}
            <Button
              {...menuButtonProps}
              leftIcon={HoursIcon}
            >
              <Link to="/hours" sx={{ color: COLOR.PRIMARY }}>
                Hours
              </Link>
            </Button>
          </Row>
        </Row>
      </MaximumReadableWidth>
    </Row>
  )
}

export default MainNavigation
